var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isDev
    ? _c("div", { staticClass: "environment-banner" }, [
        _vm._v("\n    测试环境\n"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }